import * as React from "react";
import { Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withModal, WithModal } from "Components/General/Modal/withModal";
import { notificationError } from "utils/libHelpers/AntdNotification";
import { workflowsStore } from "Pages/Admin/Stores/WorkflowsStore";
import { WorkflowForm } from "../Pages/WorkflowForm";
import { FlowchartModal } from "Pages/Project/Workflow/Pages/ProcessStep/Component/FlowchartModal";
import { modal } from "Components/General/Modal/AntdModal";

const MODAL_PROPS = { width: `100%`, style: { maxWidth: 720, top: 20 }, footer: null, destroyOnHidden: true };
interface WorkflowTableRowActionsProps extends WithTranslation, WithModal {
  data: API_AdminWorkflowDefinitionDetails;
  children: React.ReactNode;
}

export const WorkflowTableRowActions = withTranslation(I18N_NS.PROJECT)(
  observer(
    withModal(
      class extends React.Component<WorkflowTableRowActionsProps> {
        handleMenuClick = ({ key, domEvent }) => {
          domEvent.preventDefault();
          domEvent.stopPropagation();
          const { data, t } = this.props;
          if (key === "delete") {
            modal.confirm({
              title: t("Are you sure?"),
              okText: t("Yes"),
              cancelText: t("No"),
              onOk: () => this.doFileClick(key, data),
            });
          } else {
            this.doFileClick(key, data);
          }
        };

        render() {
          return (
            <Dropdown
              menu={{
                items: [
                  {
                    key: "edit",
                    label: (
                      <>
                        <FontAwesomeIcon icon={["far", "edit"]} fixedWidth={true} className="mr-5" />
                        {this.props.t("Edit")}
                      </>
                    ),
                  },
                  {
                    key: "chart",
                    label: (
                      <>
                        <FontAwesomeIcon icon={["far", "project-diagram"]} fixedWidth={true} className="mr-5" />
                        {this.props.t("Show diagram")}
                      </>
                    ),
                  },
                ],
                onClick: this.handleMenuClick,
                className: "documents-actions",
              }}
              trigger={["click"]}
            >
              {this.props.children}
            </Dropdown>
          );
        }

        private doFileClick = (key: string, data: API_AdminWorkflowDefinitionDetails) => {
          const { t } = this.props;

          switch (key) {
            case "edit":
              (async () => {
                await workflowsStore.fetchByWfId(data.id);
                this.props.showModal(WorkflowForm, {
                  modalProps: { ...MODAL_PROPS, title: t("Workflow definition") },
                  componentProps: {
                    onEdit: workflowsStore.edit,
                    onCreate: workflowsStore.save,
                    initialData: workflowsStore.submitData,
                  },
                });
              })();
              break;
            case "chart":
              (async () => {
                // await workflowChartStore.fetch(data.id, false, workflowsStore.projectId);
                this.props.showModal(FlowchartModal, {
                  modalProps: {
                    footer: null,
                    maskClosable: true,
                    width: "100%",
                    title: " ",
                    style: { minHeight: 550 },
                    zIndex: 1013,
                    className: "full-height-modal",
                  },
                  componentProps: {
                    adminProjectId: data.id,
                  },
                });
              })();
              break;
            default:
              notificationError(t("Error"), "Unknown action" + key);
              break;
          }
        };
      }
    )
  )
);
